<template>
  <div class="page-footer">
    <div class="copyright">© 版权所有 <span class="year">{{year}}</span></div>
    <div class="copyright"><a href="http://www.qmdqmgs.com/"> 奇门咨询 – 叶老师的奇门遁甲之道</a></div>
    <div class="beian"><a href="http://www.beian.miit.gov.cn/" target="_blank"> 冀ICP备14017109号-3</a></div>
    <div class="weixin" @click="$emit('showHotLine')"><img src="../assets/images/weixin-icon.svg"><span>叶老师微信</span></div>
  </div>
</template>

<script>
export default {
  name: 'page-footer',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang=scss>
  .page-footer{
    text-align: center;
    padding: 30px 0;
    a{
      color: inherit;
      text-decoration: none;
    }
  }
  .weixin{
    position: fixed;
    bottom: 50px;
    right: 15px;
    width: 72px;
    font-size: 12px;
    z-index: 5;
    text-align: center;
    span{
      background-color: $red;
      box-shadow: #fff 0 0 0 3px inset, rgba(0,0,0,.4) 0 2px 5px;
      color: #fff;
      padding: 5px 5px;
      white-space: nowrap;
    }
    img{
      width: 60px;
      margin: auto;
      display: block;
      padding: 0;
      border-radius: 50%;
      background-color: #fff;
      box-shadow: rgba(0,0,0,.4) 0 2px 5px;
    }
  }
</style>
